import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.upgrade-license.seat', {
        url: '/seat',
        component: 'upgradeLicenseSeat',
        resolve: {},
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/upgrade/seat/add-seat.state.js